import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "references-detail-pane iodine-no-scroll-y full-height text-center flex column" }
const _hoisted_2 = { class: "reference-content-container iodine-scrollable-y" }
const _hoisted_3 = {
  key: 0,
  class: "highlight-nav-bar-container"
}
const _hoisted_4 = { class: "highlight-nav-bar-container-inner" }
const _hoisted_5 = { class: "switch" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "slider" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "highlight-nav-bar-title" }, "Highlight Matched Term", -1)
const _hoisted_8 = { class: "highlight-nav-bar" }

import {ref, watch, onMounted, VNodeRef} from 'vue';

import ReferencesDetailTitle from 'components/references/ReferencesDetailTitle.vue';
import ReferencesDetailToolbar from 'components/references/ReferencesDetailToolbar.vue';
import ReferencesContent from 'components/references/ReferencesContent.vue';
import {storeToRefs} from 'pinia';
import {ReferencesHistoryData, useTrucodeReferenceStore} from 'stores/references-store';
import {useHistoryStore} from 'stores/history-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesDetail',
  setup(__props) {

const referenceStore = useTrucodeReferenceStore();
const history = useHistoryStore<ReferencesHistoryData>('references-history', (one: ReferencesHistoryData, two: ReferencesHistoryData) => {
  return one?.id === two?.id;
});
const {currentArticle, highlightMatchedTerms} = storeToRefs(referenceStore);

const curReferencesHistoryData = ref<ReferencesHistoryData>();
const referencesContentRef = ref<VNodeRef | null>(null)

onMounted(async () => {
  await useTrucodeReferenceStore().getHighlightMatchedTermsValueTerms()
});

// eslint-disable-next-line
function highlightMatchedTermsChanged(event: any) {
  useTrucodeReferenceStore().updateHighlightMatchedTerms(event.currentTarget?._modelValue)
}

watch(currentArticle, (newData) => {
  curReferencesHistoryData.value = history.addToHistory(<ReferencesHistoryData>newData);
});

const onBackButtonClicked = () => {
  curReferencesHistoryData.value = history.getPrev();
};

const nextTermClick = () => {
  referencesContentRef?.value?.handleNextTermClick();
}

const previousTermClick = () => {
  referencesContentRef?.value?.handlePreviousTermClick();
}

const onNextButtonClicked = () => {
  curReferencesHistoryData.value = history.getNext();
};

const onPrintButtonClicked = () => {
  console.log('Print button clicked');
};

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReferencesDetailTitle, {
      "book-description": curReferencesHistoryData.value?.bookDescription
    }, null, 8, ["book-description"]),
    _createVNode(ReferencesDetailToolbar, {
      "enable-back-button": _unref(history).isPrevAvailable,
      "enable-next-button": _unref(history).isNextAvailable,
      "title-description": curReferencesHistoryData.value?.articleDescription,
      onBackButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (onBackButtonClicked())),
      onNextButtonClicked: _cache[1] || (_cache[1] = ($event: any) => (onNextButtonClicked())),
      onPrintButtonClicked: _cache[2] || (_cache[2] = ($event: any) => (onPrintButtonClicked()))
    }, null, 8, ["enable-back-button", "enable-next-button", "title-description"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ReferencesContent, {
        ref_key: "referencesContentRef",
        ref: referencesContentRef,
        "article-id": (curReferencesHistoryData.value?.articleId as string),
        "highlight-matched-terms": _unref(highlightMatchedTerms)
      }, null, 8, ["article-id", "highlight-matched-terms"])
    ]),
    (_unref(referenceStore).getMode === 'search')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(highlightMatchedTerms) ? (highlightMatchedTerms).value = $event : null)),
                onChange: highlightMatchedTermsChanged
              }, null, 544), [
                [_vModelCheckbox, _unref(highlightMatchedTerms)]
              ]),
              _hoisted_6,
              (_unref(highlightMatchedTerms))
                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                    key: 0,
                    anchor: "bottom middle",
                    self: "top middle"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Turn Off Highlight Matched Terms")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(highlightMatchedTerms))
                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                    key: 1,
                    anchor: "bottom middle",
                    self: "top middle"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Turn On Highlight Matched Terms")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_q_btn, {
                class: "io-mfe-ig-icon-button-medium",
                id: "back-nav-button",
                round: "",
                disable: !_unref(highlightMatchedTerms),
                onClick: previousTermClick
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, { name: "fa-light fa-chevron-left" }),
                  (_unref(highlightMatchedTerms))
                    ? (_openBlock(), _createBlock(_component_q_tooltip, {
                        key: 0,
                        anchor: "bottom middle",
                        self: "top middle"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Previous")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disable"]),
              _createVNode(_component_q_btn, {
                class: "io-mfe-ig-icon-button-medium",
                id: "next-nav-button",
                round: "",
                disable: !_unref(highlightMatchedTerms),
                onClick: nextTermClick
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, { name: "fa-light fa-chevron-right" }),
                  (_unref(highlightMatchedTerms))
                    ? (_openBlock(), _createBlock(_component_q_tooltip, {
                        key: 0,
                        anchor: "bottom middle",
                        self: "top middle"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Next")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disable"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})